/**
 * A form's confirmation copy is written in admin, so its links are written in
 * the text: `[Instagram](https://www.instagram.com/pollinator_coop/)` reads as
 * the word Instagram, linked. An address written out bare still becomes a
 * link, showing the address, so copy written before link text was possible
 * keeps working. A full stop or comma straight after a bare address is left
 * outside the link.
 */
const LINK_PATTERN =
  /(\[[^\]]+\]\(https?:\/\/[^)\s]+\)|https?:\/\/[^\s]+?(?=[.,]?(?:\s|$)))/;
const NAMED_LINK = /^\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)$/;

export function withLinks(text: string) {
  return text.split(LINK_PATTERN).map((part, i) => {
    const named = NAMED_LINK.exec(part);
    const href = named ? named[2] : /^https?:\/\//.test(part) ? part : undefined;
    if (!href) return part;
    return (
      <a
        key={i}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="underline decoration-[1.5px] underline-offset-[5px] hover:text-brand-700"
      >
        {named ? named[1] : part}
      </a>
    );
  });
}
